import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { Toast } from 'vant';

Vue.use(Toast)

import vueWechatTitle from 'vue-wechat-title'
Vue.use(vueWechatTitle)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {  ak: '9PrNW7PBttIXu2FG9ZrXOX6ZtUIkEwYf'})


Vue.prototype.btColor = 'linear-gradient(127deg, #b0c0ff 0%, #4d6aff 100%)'

Vue.prototype.$getDays = function(num){
  var date = new Date();

  date.setDate(date.getDate() + num)

  let year = date.getFullYear()				//年
  let month = date.getMonth() + 1				//月
  let day = date.getDate();					//天数
  if(month >= 1 && month <= 9) {
    month = `0${month}`
  }
  if(day >= 1 && day <= 9) {
    day = `0${day}`
  }
  return `${year}-${month}-${day}`
}


import utils from './utils/utils';
Vue.prototype.utils = utils

//import wx from "weixin-js-sdk"
//Vue.prototype.wx = wx

import './style/reset.scss'
import './style/common.scss'
import './style/animate.min.css'
import 'swiper/css/swiper.min.css'
import './utils/rem'


Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  next()
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


